
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import { getIsknDateTitle } from '../../reducers/iskn';

import IsknParList from '../common/iskn/IsknParList';
import ParHistoryDialog from '../common/iskn/ParHistoryDialog';
import OverviewPanel from '../projectOverviewPage/OverviewPanel';
import IfComp from '../common/IfComp';

const classNames = mergeStyleSets({
    parInfo: {
        paddingBottom: 16
    },
    par: {
        paddingLeft: 16
    }
});

const ParcelInfo = ({infoData, isknDate}) => {
    const isknDateTitle = useSelector(state => getIsknDateTitle(state.iskn, isknDate));

    const handleShowHistory = async (parItem) => {
        const dialog = ParHistoryDialog();
        await dialog.open(parItem.par_id);
    }

    const tools = [{
        title: 'Zobrazit historii',
        handler: handleShowHistory
    }]

    return (
        <Stack className={classNames.parInfo}>
            <Stack.Item>
                <Text>Seznam parcel se převodem vlastnictví v datové sadě: </Text>
                <Text bold >{isknDateTitle}</Text>
            </Stack.Item>
            <Stack.Item className={classNames.par}>
                <IsknParList
                    compact={false}
                    isknDate={isknDate}
                    data={infoData}
                    tools={tools}
                />
            </Stack.Item>
        </Stack>
    );
}

const MovedParcel = ({data}) => {

    const existsPar = data.reduce((previous, current) => {
        return (current.parId.length > 0)
            ? true
            : previous;
    }, false);

    if (existsPar) {
        return data.map(item => {
            return (item.info && item.info.par.length > 0)
                ? <ParcelInfo
                    key={item.isknDate}
                    infoData={item.info}
                    isknDate={item.isknDate}
                />
                : null;
        });
    } else {
        return (
            <Text>Žádný převod vlastnictví mezi vybranými vlastníky nebyl nalezen.</Text>
        );
    }
}

const Analyze2OpsubResult = ({
    data,
    isLoaded
}) => {

    const dataMovedPar = data?.movedPar;

    return (
        <OverviewPanel title="ANALÝZA PŘEVODU MEZI VLASTNÍKY" loaded={isLoaded} panelWidth="auto" >
            <IfComp cond={dataMovedPar}>
                <MovedParcel
                    data={dataMovedPar}
                />
            </IfComp>
        </OverviewPanel>
    );
}

export default Analyze2OpsubResult;
